import datacentral from '@/utils/axios/datacentral'
import { AnalyticQuery, ServiceAnalyticMonitoring } from '../types'
import qs from 'query-string'
import { ResponseArray } from '@/types/shared'

const fetchServiceAnalyticMonitorings = async (queries: AnalyticQuery) => {
    return await datacentral.get<ResponseArray<ServiceAnalyticMonitoring>>(
        `/services/analytics/monitorings?${qs.stringify(queries, { arrayFormat: 'bracket' })}`
    )
}

export const getServiceAnalyticMonitorings = async (queries: AnalyticQuery) => {
    const response = await fetchServiceAnalyticMonitorings(queries)
    return response?.data || []
}
